
const getSizeOfProduct = (product) => {
    if (product === undefined) return null
    let size = product?.size
    size = {
        width: Math.round(size.x * 1000),
        height: Math.round(size.y * 1000),
    }
    return size
}

export default getSizeOfProduct;